import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  IUserFeedbackAnswer,
  IUserFeedbackQuestion,
  IUserFeedbackQuestionContextType,
} from 'models-user-feedback';
import { Observable } from 'rxjs';

import { USER_FEEDBACK_API_TOKEN } from './token';

@Injectable()
export class UserFeedbackService {
  private readonly api = inject(USER_FEEDBACK_API_TOKEN);
  private readonly http = inject(HttpClient);

  public getQuestion(
    contextType: IUserFeedbackQuestionContextType = IUserFeedbackQuestionContextType.OrderPlaced,
  ): Observable<IUserFeedbackQuestion> {
    return this.http.get<IUserFeedbackQuestion>(
      `${this.api}/question?contextType=${contextType}`,
    );
  }

  public submitAnswer(answer: IUserFeedbackAnswer) {
    return this.http.post(`${this.api}/answer`, answer);
  }
}
